import React, { useLayoutEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { AnimatePresence, motion } from "framer-motion";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";

import { HelmetProvider } from "react-helmet-async";

/* SERVICE PAGES */
import SocialMediaMarketing from "./pages/services/SocialMediaMarketing";
import SocialMediaOptimization from "./pages/services/SocialMediaOptimization";
import WhatsappMarketing from "./pages/services/WhatsappMarketing";
import GoogleAds from "./pages/services/GoogleAds";
import MetaAds from "./pages/services/MetaAds";
import WebsiteDesign from "./pages/services/WebsiteDesign";
import WebsiteDevelopment from "./pages/services/WebsiteDevelopment";
import DomainHosting from "./pages/services/DomainHosting";
import WebsiteMaintenance from "./pages/services/WebsiteMaintenance";
import ECommerce from "./pages/services/ECommerce";
import GraphicDesign from "./pages/services/GraphicDesign";
import SEO from './pages/services/Seo';

const pageVariants = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -40 },
};

function PageWrapper({ children }) {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.4 }}
    >
      {children}
    </motion.div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
          <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
          <Route path="/about/team" element={<PageWrapper><Team /></PageWrapper>} />
          <Route path="/services" element={<PageWrapper><Services /></PageWrapper>} />
          <Route path="/blog" element={<PageWrapper><Blog /></PageWrapper>} />
          <Route path="/blog/:slug" element={<PageWrapper><BlogDetails /></PageWrapper>} />
          <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />

          <Route path="/services/social-media-marketing" element={<PageWrapper><SocialMediaMarketing /></PageWrapper>} />
          <Route path="/services/social-media-optimization" element={<PageWrapper><SocialMediaOptimization /></PageWrapper>} />
          <Route path="/services/whatsapp-marketing" element={<PageWrapper><WhatsappMarketing /></PageWrapper>} />
          <Route path="/services/google-ads" element={<PageWrapper><GoogleAds /></PageWrapper>} />
          <Route path="/services/meta-ads" element={<PageWrapper><MetaAds /></PageWrapper>} />
          <Route path="/services/website-design" element={<PageWrapper><WebsiteDesign /></PageWrapper>} />
          <Route path="/services/website-development" element={<PageWrapper><WebsiteDevelopment /></PageWrapper>} />
          <Route path="/services/domain-hosting" element={<PageWrapper><DomainHosting /></PageWrapper>} />
          <Route path="/services/website-maintenance" element={<PageWrapper><WebsiteMaintenance /></PageWrapper>} />
          <Route path="/services/ecommerce-development" element={<PageWrapper><ECommerce /></PageWrapper>} />
          <Route path="/services/graphic-design" element={<PageWrapper><GraphicDesign /></PageWrapper>} />
          <Route path="/services/seo" element={<PageWrapper><SEO /></PageWrapper>} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <AnimatedRoutes />
      </Router>
    </HelmetProvider>
  );
}